import { render } from "./ViewApproval.vue?vue&type=template&id=0f9a3287"
import script from "./ViewApproval.vue?vue&type=script&lang=js"
export * from "./ViewApproval.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abola\\Documents\\A.Personal Dev\\CHI\\assetmentainance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__